import React, { useEffect, useState } from 'react'

import { Button } from 'primereact/button'
import { Input, Row, Typography } from 'antd'

import { getMessage } from '../../../util/IntlMessages'
import { api, request } from '../../../util/handlerRequestUtil'

const CreateGroup = ({ groupId, setModalGroupVisible, customerId, currentGroupName, updateGroupsList }) => {
  const [groupName, setGroupName] = useState('')
  const [groupNameError, setGroupNameError] = useState({ error: false, message: '' })

  useEffect(() => {
    if (currentGroupName) {
      setGroupName(currentGroupName)
    }
  }, [groupId])

  const handleSubmit = async () => {
    const validationError = await validateGroupName(groupName)

    if (validationError) {
      setGroupNameError(validationError)
      return
    }

    const data = {
      description: groupName.toUpperCase(),
      customerId: +customerId
    }

    if (groupId) {
      await updateGroup(groupId, data)
    } else {
      const group = await createGroup(data)
      updateGroupsList({ ...group, documents: [] })
    }

    setModalGroupVisible()
    setGroupName('')
    return
  }

  const createGroup = async (data) => {
    try {
      const response = await request(api.createCustomerGroup(data))
      return response
    } catch (error) {
      setGroupNameError({ error: true, message: error.message })
    }
  }

  const updateGroup = async (id, data) => {
    try {
      await request(api.updateCustomerGroup(id, data))
    } catch (error) {
      setGroupNameError({ error: true, message: error.message })
    }
  }

  async function groupExistCheck(groupNameCheck) {
    let groupExist = false
    const groups = await request(api.listCustomerGroupByCustomerId(customerId), false, true)

    await groups.forEach((group) => {
      if (group.description.toUpperCase().replace(/\s/g, '') === groupNameCheck.toUpperCase().replace(/\s/g, '')) {
        groupExist = true
      }
    })
    return groupExist
  }

  const validateGroupName = async (groupName) => {
    if (!groupName) {
      return { error: true, message: 'O nome do grupo não pode estar vazio' }
    }

    const groupExists = await groupExistCheck(groupName)

    if (groupExists) {
      return { error: true, message: 'Já existe um grupo com esse nome' }
    }
    return null
  }

  return (
    <>
      <Typography level={3}>{getMessage('groupNameCreate')}</Typography>
      <Input value={groupName} onChange={(e) => setGroupName(e.target.value)} />

      {groupNameError.error && <span style={{ color: '#f5222d' }}>{getMessage(groupNameError.message)}</span>}
      <Row type="flex" justify="space-around" style={{ marginTop: 5 }}>
        <Button
          onClick={() => {
            setGroupName('')
            setModalGroupVisible(false)
            setGroupNameError('')
          }}
        >
          {getMessage('cancel')}
        </Button>
        <Button onClick={handleSubmit}>{groupId ? getMessage('update') : getMessage('storeContacts')}</Button>
      </Row>
    </>
  )
}

export default CreateGroup
